// Batch 30 · M73 / M74: engagement team (creator on the team, add at your level or below) and the lasting GL Import
// refusal (EN + AR). Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_B30_TEAM = {
  en: {
    engTeam: {
      levelNote: "You can add team members at your own level or below ({roles}).",
      readOnly: "Only a manager on the team, the engagement's creator, a Partner or a Firm Admin can add or remove team members.",
      addRefused: "This change to the team was not made",
    },
    gl: {
      refusedTitle: "This upload was not accepted",
      dismiss: "Dismiss",
    },
  },
  ar: {
    engTeam: {
      levelNote: "يمكنك إضافة أعضاء إلى الفريق في مستواك أو أدنى ({roles}).",
      readOnly: "لا يضيف أعضاء الفريق أو يزيلهم إلا مدير ضمن الفريق أو منشئ المهمة أو الشريك أو مسؤول المكتب.",
      addRefused: "لم يُنفَّذ هذا التغيير على الفريق",
    },
    gl: {
      refusedTitle: "لم يُقبل هذا الرفع",
      dismiss: "إغلاق",
    },
  },
};

export default I18N_B30_TEAM;
